import { render, staticRenderFns } from "./ModalVerifyPhone.vue?vue&type=template&id=5318ae92&scoped=true&"
import script from "./ModalVerifyPhone.vue?vue&type=script&lang=js&"
export * from "./ModalVerifyPhone.vue?vue&type=script&lang=js&"
import style0 from "./ModalVerifyPhone.vue?vue&type=style&index=0&id=5318ae92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318ae92",
  null
  
)

export default component.exports